import { API_URL } from "./api";

export const newContact = async (email, firstname = '', lastname = '') => {
    try {
      const response = await fetch(`${API_URL}/api/mailjet/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email, firstname, lastname })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Mailjet error:', errorData);
        throw new Error('Subscription failed');
      }
  
      const data = await response.json();
      console.log('Subscription response:', data);
  
      return { success: true, message: 'Subscription successful', data };
    } catch (err) {
      console.error('Error during subscription:', err);
      return { success: false, message: 'Error during subscription' };
    }
  };
  